// Global Layouts
import layoutBox from './layoutBox'
import layoutHeader from './layoutHeader'
import layoutSplash from './layoutSplash'

// Colour Palettes
import paletteContrast from './paletteContrast'
import paletteLight from './paletteLight'

// Custom
import gns3 from './gns3'
import motherWebsite from './motherWebsite'

const defaults = {
   // Global
   tmpAppInnerPaddingHorizontal: '20px[a-b] 40px[c] 30px[d] 40px[e-f]', // Protoype padding
   tmpAppOuterPaddingHorizontal: '20px[a-b] 40px[c] 30px[d] 40px[e-f]', // Protoype padding
   tmpBorderRadius: '4px',
   tmpBorderRadiusContainer: '4px',
   drawerMenuButtonTextSize: '3',
   headerMainMenuTextSize: '1.5',
   headerMainMenuActionBlockTextSize: '1.5',
   titlebarLgHeight: '85px[a-d] 110px[e-f]',
   // Body - Text Style
   tmpBodyTextSize: '2.5',
   tmpBodyTextLineHeight: '150%',
   tmpBodyTextLgSize: '2.5[a-b] 3[c] 2.5[d] 3[e-f]',
   tmpBodyTextLgLineHeight: '160%',
   tmpSubBodyTextSize: '1.5[a-b] 1.5[c-f]',
   // Title - Text Styles
   tmpTitleXlSize: '9',
   tmpTitleXlLetterSpacing: '-0.5px',
   tmpTitleXlLineHeight: '120%',
   tmpTitleXlTransform: 'none',
   tmpTitleLgLetterSpacing: '-0.5px',
   tmpTitleLgTransform: 'none',
   tmpTitleMdLetterSpacing: '-0.2px',
   tmpTitleMdLineHeight: '120%',
   tmpTitleMdTransform: 'none',
   tmpTitleSmSize: '3.5',
   tmpTitleSmLetterSpacing: '-0.2px',
   tmpTitleSmLineHeight: '130%',
   tmpTitleSmTransform: 'none',
   tmpTitleXsSize: '2.5',
   tmpTitleXsLetterSpacing: '-0.2px',
   tmpTitleXsLineHeight: '130%',
   tmpTitleXsTransform: 'none',
   // Title - Common Styles
   tmpTitleFontFamily: 'inherit, neue-haas-grotesk-text',
   tmpTitleTextTransform: 'none',
   subtitleColor: '#777',
   subtitleSize: '3[a-b] 4[c] 3[d] 4.5[e-f]',
   subtitleLineHeight: '150%',
   // Notification Badge
   tmpNotificationBadgeColor: 'orange',
   tmpNotificationBadgeTextColor: '#111',
   // Form Style
   formStyle: {
      elementAppearance: 'plain',
      elementBackgroundColor: '#f3f3f3',
      elementFocusBackgroundColor: '#eee',
      labelTextColor: '#000',
      labelTextSize: '2.5',
      labelTextTransform: 'none',
      labelTextWeight: 'medium'
   },

   // Note: These settings colours constants are highly subject to change
   // Use with care see PR #328
   protoSettingsHighlightBackgroundColor: '#342e39',
   protoSettingsHighlightForegroundColor: '#99cbff',
   viewportContentMaxWidth: '1700px',
   viewportMarginBottom: '0px',
   viewportMarginLeft: '0px',
   viewportMarginRight: '0px',
   viewportPaddingBottom: '0px[a] 2vw[b] 2vw[c] 3vh[d] 3vh[e] 2vw[f]',
   viewportPaddingLeft: '20px[a] 20px[b] 40px[c] 30px[d] 5vw[e] 150px[f]',
   viewportPaddingRight: '20px[a] 20px[b] 40px[c] 30px[d] 5vw[e] 150px[f]',
   viewportPaddingTop: '30px[a] 7vw[b] 5vw[c] 6vh[d] 8vh[e] 3vw[f]',

   // Unsorted Props - to be deprecated
   tmpNoteMetaTextColor: '#aaa',
   tmpNotePadding: '40px',
   tmpNoteMaxWidth: '40em',
   tmpBorderColor: '#eaeaea',
   tmpButtonTextColor: '#555',
   tmpContentTitleColor: '#111',
   tmpContentTextColor: '#211e1e',
   tmpCtaButtonHeight: '35px[a-d] 40px[e] 45px[f]',
   tmpNavTextColor: '#000',
   tmpTitlebarHeight: '15vh',
   tmpTitlebarMaxHeight: '90px[a-d] 100px[e] 110px[f]',
   tmpTitlebarMinHeight: '80px[a-d] 90px[e] 100px[f]',
   tmpTitleColor: '#111',
   tmpToolbarHeight: '65px',
   tmpPrimaryButtonTextFontWeight: '500',
   tmpPrimaryButtonTextTransform: 'none',
   tmpSecondaryButtonTextFontWeight: '500',
   tmpViewMode: 'sidebar'
}

export default {
   _defaults: {
      ...defaults,
      ...layoutHeader,
      ...paletteLight
   },
   'banff-pipeline-workshop': {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   },
   'teacher-education-and-certification-committee': {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   },
   'edmonton-area-field-experiences-committee-eafec': {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   },
   lafec: {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   },
   eyeq: {
      ...defaults,
      ...layoutHeader,
      ...paletteContrast,
      tmpMainMenuBackgroundColor: '#103154',
      tmpMainMenuButtonTextColor: 'rgba(255,255,255,0.5)'
   },
   // TODO: Bring this back when Fuse can properly use bleeding edge
   // PR #701
   fuse: {
      ...defaults,
      ...layoutHeader,
      ...paletteContrast
   },
   gns3: {
      ...defaults,
      ...layoutHeader,
      ...paletteContrast,
      ...gns3
   },
   'mother-co': {
      ...defaults,
      ...layoutBox,
      ...paletteLight,
      tmpBodyTextColor: '#444',
      tmpBodyTextLineHeight: '160%',
      tmpContentLineColor: '#e5e5e5',
      tmpContentTitleColor: '#222',
      tmpMainMenuButtonActiveBackgroundColor: '#F0EEEB',
      tmpMainMenuButtonTextColor: '#666',
      tmpTitleXlSize: '9'
   },
   'mother-website': {
      ...defaults,
      ...layoutHeader,
      ...paletteLight,
      ...motherWebsite
   },
   'ajay-sabhaney': {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   },
   'steven-yuen': {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   },
   'tool-terminal': {
      ...defaults,
      ...layoutSplash,
      ...paletteLight
   },
   'walking-together': {
      ...defaults,
      ...layoutBox,
      ...paletteLight
   }
}
